import './publicationlink.less'

import {action, classes, Component} from '@codeurs/front'
import m from 'mithril'
import {t} from 'store'
import {AuthorType, WysiwygType} from 'types/types'
import {getAllThemesFromLists} from 'util/tags'
import Author from 'views/layout/author'
import PublishedDate from 'views/layout/date'
import Link from 'views/layout/link'
import TagLink from 'views/layout/taglink'
import Wysiwyg from 'views/layout/wysiwyg'
import PublicationImage from './publicationimage'

export type PublicationType = {
	id: number
	author: AuthorType
	date: string
	tags: Array<string>
	path: string
	url: string
	label: Array<string>
	description: WysiwygType
	title: string
	publication_title: string
	publication_subtitle: string
	publication_file: PublicationFile
	mod?: string
	policy?: Array<string>
	sector?: Array<string>
}

export type PublicationFile = {
	description: string
	target: string
	title: string
	type: string
	url: string
	size: string
}

export default class PublicationLink extends Component<{
	publication: PublicationType
	tags: Array<string>
	mod?: string
	lists?: any
}> {
	view() {
		const {
			author,
			date,
			path,
			url = window.location.pathname + '/' + path,
			label,
			description,
			title,
			publication_file,
			publication_subtitle,
			publication_title,
			policy,
			sector
		} = this.attrs.publication
		const {tags, mod, lists} = this.attrs
		return m('.publicationlink', classes({mod}), [
			m('.publicationlink-left',
				m(Link,
					action(url),
					m(PublicationImage, {
						publication_subtitle,
						publication_title,
						label,
						featured: false
					})
				)
			),
			this.getRightView(
				author,
				date,
				tags,
				url,
				description,
				title,
				publication_file,
				lists,
				policy,
				sector
			)
		])
	}
	getRightView(
		author: AuthorType,
		date: string,
		tags: Array<string>,
		url: string,
		description: WysiwygType,
		title: string,
		publication_file: PublicationFile,
		lists: any,
		policy: Array<string>,
		sector: Array<string>
	) {
		const {mod} = this.attrs
		return m('.publicationlink-right', classes({mod}), [
			m(Link,
				action(url),
				m('h2.publicationlink-right-title', classes({mod}), title)
			),
			m('.publicationlink-right-top', [
				m(Author, {author, class: 'publicationlink-right-top-author'}),
				m(PublishedDate, {date})
			]),
			m('.publicationlink-right-bottom', [
				m(Wysiwyg, {
					class: 'publicationlink-right-bottom-description',
					html: description
				}),
				m(Link,
					{
						...action(url),
						...classes(
							{mod: ['blue', mod]},
							'publicationlink-right-bottom-link'
						)
					},
					[
						m('.publicationlink-right-bottom-link-text',
							t('articles.readmore')
						),
						m('.publicationlink-right-bottom-link-arrow', '>')
					]
				),
				m('.publicationlink-right-bottom-tagscontainer', [
					tags[0] &&
						m('.publicationlink-right-bottom-tagscontainer-title',
							t('articles.tags') + ':'
						),
					this.getTags(tags)
				]),
				mod == 'search' &&
					(policy[0] || sector[0]) &&
					m('.publicationlink-right-bottom-tagscontainer', [
						m('.publicationlink-right-bottom-tagscontainer-title',
							t('articles.themes') + ':'
						),
						this.getTags(getAllThemesFromLists(lists, policy, sector))
					])
			])
		])
	}

	getTags(tags: Array<string>) {
		if (tags) {
			const lastTag = tags.slice(-1)[0]
			return tags.map(tag =>
				m(TagLink, {
					text: tag,
					mod: 'tag'
				})
			)
		}
		return
	}
}
